import type React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { yieldCallback } from '@zillow/yield-callback';

import Button from 'app/shared/core/Button';
import {
  ContactCallToActionBtn,
  ContactCallToActionContainer,
  contactTodayTextCss,
} from './ContactCallToAction.styles';
import Title from '../Title';

interface ContactCallToActionProps {
  onCtaClick?: () => void;
}

const ContactCallToAction: React.FC<ContactCallToActionProps> = ({ onCtaClick }) => {
  const dispatch = useDispatch();

  const yieldHandleClick = useCallback(
    () =>
      yieldCallback(() => {
        if (onCtaClick) {
          onCtaClick();
        }
      })(),
    [onCtaClick, dispatch],
  );

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      yieldHandleClick();
    },
    [yieldHandleClick],
  );

  return (
    <ContactCallToActionContainer>
      <Title className={contactTodayTextCss} size="md" htmlTag="div">
        Like what you see? Places go fast. <br />
        Contact today!
      </Title>
      <ContactCallToActionBtn>
        <Button size="sm" onClick={handleClick}>
          Send an email
        </Button>
      </ContactCallToActionBtn>
    </ContactCallToActionContainer>
  );
};

export { ContactCallToAction };
export default ContactCallToAction;
